import { useGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useGuttagekonto';
import { useUpdateGuttagekonto } from '@/domain/mitarbeiter/features/guttagekonto/hooks/useUpdateGuttagekonto';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
  Field,
  FieldError,
  FieldLabel,
  Input,
  toast,
} from '@e2n/ui/v2';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { t } from 'i18next';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function GuttagekontoUebertragCard() {
  const { id } = useParams();
  const currentYear = dayjs().year();
  const { guttagekonto } = useGuttagekonto([id ?? ''], currentYear);
  const { updateGuttagekonto } = useUpdateGuttagekonto();
  const [value, setValue] = useState(guttagekonto.uebertragAusVorjahr);
  const [isOpen, setIsOpen] = useState(false);

  const min = -99.5;
  const max = 99.5;
  const parseToFloat = (val: string | number): number => {
    if (val === null || val === undefined) return NaN;
    const adjustValue = String(val).replace(',', '.');
    return parseFloat(adjustValue);
  };
  const parsedValue = parseToFloat(value);

  const checkInput =
    parsedValue % 0.5 === 0 &&
    parsedValue >= min &&
    parsedValue <= max &&
    !isNaN(parsedValue);

  const handleValueChange = (uebertrag: string) => {
    const parsedUebertrag = parseToFloat(uebertrag);
    if (/^-?[0-9]*[.,]?[0-9]*$/.test(uebertrag)) {
      setValue(parsedUebertrag);
    } else {
      setValue(value);
    }
  };

  function handleUpdateGuttagekonto() {
    updateGuttagekonto(id ?? '', guttagekonto.jahr, value);
    toast({
      variant: 'success',
      title: t('domain.mitarbeiter.guttagekonto.uebertragSpeichern'),
    });
    setIsOpen(false);
  }
  return (
    <>
      <div className="block md:hidden">
        <Drawer>
          <DrawerTrigger asChild>
            <Button iconOnly variant="secondary-red">
              <FontAwesomeIcon icon={faPen} size="lg" />
            </Button>
          </DrawerTrigger>
          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle>
                {t('domain.mitarbeiter.guttagekonto.uebertrag')}
              </DrawerTitle>
            </DrawerHeader>
            <DrawerBody>
              <Field>
                <FieldLabel htmlFor="Anzahl" requiredField>
                  {t('domain.mitarbeiter.guttagekonto.anzahl')}
                </FieldLabel>
                <Input
                  type="text"
                  placeholder="0"
                  showSuffix
                  suffix="Tage"
                  onChange={(e) => handleValueChange(e.target.value)}
                  maxLength={max}
                  minLength={min}
                  step=".5"
                />
              </Field>
              {!checkInput && (
                <FieldError
                  errors={[
                    {
                      message:
                        'Gib einen Zahlenwert zwischen -99.5 und 99.5 ein.',
                    },
                  ]}
                />
              )}
              <DrawerFooter>
                <Button
                  disabled={!checkInput}
                  variant="primary-pill"
                  onClick={handleUpdateGuttagekonto}>
                  {t('domain.mitarbeiter.guttagekonto.fertig')}
                </Button>
                <DrawerClose asChild>
                  <Button
                    variant="secondary-blue"
                    onClick={() => setIsOpen(false)}>
                    {t('domain.mitarbeiter.guttagekonto.abbrechen')}
                  </Button>
                </DrawerClose>
              </DrawerFooter>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </div>
      <div className="hidden md:block">
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogTrigger asChild>
            <Button iconOnly variant="secondary-red">
              <FontAwesomeIcon icon={faPen} size="lg" />
            </Button>
          </DialogTrigger>
          <DialogContent size="md">
            <DialogHeader className="p-4">
              <DialogTitle>
                {t('domain.mitarbeiter.guttagekonto.uebertrag')}
              </DialogTitle>
              <Field>
                <FieldLabel htmlFor="Anzahl" requiredField>
                  {t('domain.mitarbeiter.guttagekonto.anzahl')}
                </FieldLabel>
                <Input
                  type="text"
                  placeholder="0"
                  showSuffix
                  suffix="Tage"
                  defaultValue={value}
                  onChange={(e) => handleValueChange(e.target.value)}
                  maxLength={max}
                  minLength={min}
                  step=".5"
                />
              </Field>
              {!checkInput && (
                <FieldError
                  errors={[
                    {
                      message:
                        'Gib einen Zahlenwert zwischen -99.5 und 99.5 ein.',
                    },
                  ]}
                />
              )}
            </DialogHeader>
            <DialogFooter variant="default">
              <Button variant="secondary-blue" onClick={() => setIsOpen(false)}>
                {t('domain.mitarbeiter.guttagekonto.abbrechen')}
              </Button>
              <Button
                disabled={!checkInput}
                variant="primary-pill"
                onClick={handleUpdateGuttagekonto}>
                {t('domain.mitarbeiter.guttagekonto.fertig')}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}
